(function () {
  const initHero = (section) => {
    if (!section || !section?.classList.contains("hero-section")) {
      return;
    }

    const slider = section.querySelector(".hero__media--slider");

    if (!slider) return;

    const sliderSpeed = Number(slider.dataset?.sliderSpeed*1000 || 6000);
    console.log("Initializing hero slider with speed:", slider.dataset?.sliderSpeed);

    const swiper = new Swiper(slider, {
      loop: true,
      allowTouchMove: false,
      spaceBetween: 0,
      speed: 600,
      slidesPerView: 1,
      initialSlide: 0,
      resizeObserver: false,
      autoplay: {
        delay: sliderSpeed,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".hero__pagination",
        type: "bullets",
        clickable: true,
      },
      breakpoints: {
        576: {
          speed: 600,
        },
      },
      on: {
        init: function () {
          // Ensure wrapper is properly positioned after initialization
          const wrapper = slider.querySelector(".hero__media-wrapper");
          if (wrapper) {
            wrapper.style.transform = "";
          }
        },
      },
    });

    // Pause autoplay on hover
    slider.addEventListener("mouseenter", () => {
      swiper.autoplay.stop();
    });

    // Resume autoplay on mouse leave
    slider.addEventListener("mouseleave", () => {
      swiper.autoplay.start();
    });

    // Add navigation button handlers
    const prevBtn = slider.querySelector(".hero__nav-button--prev");
    const nextBtn = slider.querySelector(".hero__nav-button--next");

    if (prevBtn) {
      prevBtn.addEventListener("click", () => swiper.slidePrev());
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", () => swiper.slideNext());
    }
  };

  initHero(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initHero(event.target);
  });
})();
